/**
 * Startscherm en menu per rol — één plek.
 *
 * Doel: een nieuwe medewerker landt op zijn eigen taak en ziet enkel wat hij nodig heeft.
 * Dit is ENKEL weergave: de server blijft elke rechtencheck zelf doen (een verborgen
 * menu-item is geen beveiliging).
 *
 * Rollen (User.role): admin/owner/superadmin/manager = beheer, binnendienst = verkoper
 * ("Verkoper / binnendienst" in Instellingen), verkoper/sales = legacy-namen.
 * Plaatsers/chauffeurs/externen gaan elders al naar de plaatsers-app.
 */

export type MenuPad =
  | '/dashboard' | '/communicatie' | '/crm' | '/projecten' | '/buitendienst' | '/logistiek'
  | '/marketing' | '/planning' | '/service' | '/catalogus' | '/settings';

export interface RolProfiel {
  start: string;
  menu: MenuPad[] | 'alles';
}

const BEHEER = new Set(['admin', 'owner', 'eigenaar', 'superadmin', 'manager', 'hq']);
const VERKOPER = new Set(['binnendienst', 'verkoper', 'sales']);

export function rolProfiel(role: string | null | undefined): RolProfiel {
  const r = (role ?? '').toLowerCase();
  if (VERKOPER.has(r)) {
    return {
      start: '/crm/my-day',
      menu: ['/crm', '/communicatie', '/projecten', '/planning', '/service', '/catalogus', '/settings'],
    };
  }
  if (BEHEER.has(r)) return { start: '/dashboard', menu: 'alles' };
  // onbekende rol: niets verbergen (veiligst voor bestaande gebruikers)
  return { start: '/dashboard', menu: 'alles' };
}

export function toonInMenu(role: string | null | undefined, pad: string): boolean {
  const { menu } = rolProfiel(role);
  return menu === 'alles' || (menu as string[]).includes(pad);
}
